import React, { FunctionComponent, useEffect } from 'react';
import { AppDocDataType } from '../../pages/Apps';
import CodeBlock from '../CodeBlock/CodeBlock';
import { Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

type AppItemProps = {
  data: AppDocDataType;
  onDelete: (id: string) => void;
}

function format(str: string) {
  return str.replace(/(.) (.)/mg, '$1\n$2');
}

const AppItem: FunctionComponent<AppItemProps> = ({ data, onDelete }) => {
  return (
    <Box mb={7}>
      <Box mb={4}>
        <Typography variant="h3" component="h3">
          { data.AppName } <DeleteIcon cursor='pointer' onClick={() => onDelete(data.id)} />
        </Typography>

        <Typography variant={'subtitle1'} component="h3">
          { data.LocationId }
        </Typography>
      </Box>

      <Typography variant="subtitle2" component="h3">
        Code for insert chat widget
      </Typography>
      <CodeBlock>
        { format(data.ChatCode) }
      </CodeBlock>
    </Box>
  );
}

export default AppItem;
